export default "__VITE_ASSET__NwFdzOPv__"